<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="700px">
    <v-card>
      <v-card-title class="headline">View Client Data</v-card-title>
      <v-alert v-if="client.acceptTerms" dense text type="success">
        This client completed the
        <strong>Vendor Creation Form</strong>.
      </v-alert>
      <v-card-text>
        <v-form>
          <v-layout>
            <v-expansion-panels v-model="panels" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>Contact Details</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container>
                      <v-layout wrap>
                        <v-flex xs12 md12>
                          <label>Group</label>
                          <p>{{client.groupName || '-'}}</p>
                        </v-flex>
                        <!-- <v-flex xs12 style="margin-top:10px;margin-bottom:15px;">
                          <label>Client Logo</label>
                          <div>
                            <v-img v-if="client.logoURI !== null"
                              :lazy-src="client.logoURI"
                              :src="client.logoURI"
                              cover
                              max-width="200"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-img v-else width="200" height="200" cover
                            lazy-src="/static/img/upload-post-photo.png"
                            src="/static/img/upload-post-photo.png"
                            >
                            </v-img>
                          </div>
                        </v-flex> -->
                        <v-flex xs12 md6>
                          <label>Client Name</label>
                          <p>{{client.name || '-'}}</p>
                        </v-flex>
                        <!-- <v-flex xs12 md6>
                          <label>Contact Name</label>
                          <p>{{client.contactName || '-'}}</p>
                        </v-flex> -->
                        <v-flex xs12 md6>
                          <label>Contact Number</label>
                          <p>{{client.phoneNumber || '-'}}</p>
                        </v-flex>
                        <!-- <v-flex xs12 md6>
                          <label>Contact Email</label>
                          <p>{{client.email || '-'}}</p>
                        </v-flex> -->
                        <v-flex xs12 md6>
                          <label>Address</label>
                          <p>{{client.address || '-'}}</p>
                        </v-flex>
                        <!-- <v-flex xs12 md6 v-if="client.website">
                          <label>Website</label>
                          <p>{{client.website || '-'}}</p>
                        </v-flex> -->
                        <v-flex xs12 md6>
                          <label>Handled By</label>
                          <p>
                            <v-chip-group multiple active-class="primary--text" column>
                              <v-chip small v-for="user in dedicatedUserList" :key="user.id">
                                <v-avatar>
                                  <v-icon>account_circle</v-icon>
                                </v-avatar>
                                &nbsp;{{user.firstName || '-'}} {{user.lastName || '-'}}
                              </v-chip>
                            </v-chip-group>
                          </p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Supported By</label>
                          <p>
                            <v-chip-group multiple active-class="primary--text" column>
                              <v-chip small v-for="user in supportingUserList" :key="user.id">
                                <v-avatar>
                                  <v-icon>account_circle</v-icon>
                                </v-avatar>
                                &nbsp;{{user.firstName || '-'}} {{user.lastName || '-'}}
                              </v-chip>
                            </v-chip-group>
                          </p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Sale Person</label>
                          <p>
                            <v-chip small>
                              <v-avatar>
                                <v-icon>account_circle</v-icon>
                              </v-avatar>
                              {{salePersonUser.firstName || '-'}}
                            </v-chip>
                          </p>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <!-- contacts panel -->
                  <v-expansion-panels v-model="contactPanels" multiple v-if="client.contacts">
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Contact Person Details
                        <v-chip
                        style="max-width:30px;margin-left:5px;"
                        small>
                          <strong>{{client.contacts.length}}</strong>
                        </v-chip>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-list dense v-for="(contact, index) in client.contacts" :key="index">
                          <v-list-item dense class="justify-end" v-if="contact.includeEmail">
                            <v-icon color="green" small>mdi-check</v-icon>  Include in Email
                            <!-- <v-checkbox
                              v-model="contact.includeEmail"
                              label="Include in Email"
                              color="secondary"
                              :true-value="true"
                              :false-value="false"
                              hide-details
                              dense
                              disabled
                            ></v-checkbox> -->
                          </v-list-item>
                          <v-list-item dense>
                            <v-layout wrap>
                              <v-flex xs12 md12>
                                <label>Contact Person</label>
                                <p>{{contact.contactName || '-'}}</p>
                              </v-flex>
                            </v-layout>
                          </v-list-item>
                          <v-list-item dense>
                            <v-layout wrap>
                              <v-flex xs12 md12>
                                <label>Contact Email</label>
                                <p>{{contact.email || '-'}}</p>
                              </v-flex>
                            </v-layout>
                          </v-list-item>
                          <v-list-item dense>
                            <v-layout wrap>
                              <v-flex xs12 md12>
                                <label>Campaigns</label>
                                <p>
                                  <v-chip
                                    small
                                    v-for="(item, index) in contact.campaigns"
                                    :key="index"
                                    class="ma-1"
                                  >
                                    {{item.name}}
                                  </v-chip>
                                </p>
                              </v-flex>
                            </v-layout>
                          </v-list-item>
                          <v-divider class="ma-0 pa-0"></v-divider>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <!-- end of contacts panel -->
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Account Details</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container>
                      <v-layout wrap>
                        <v-flex xs12 md6>
                          <label>Account Budget:</label> <span>{{client.account.budget || '-'}}</span>
                        </v-flex>
                        <!-- <v-flex xs12 md6>
                          <label>No. of Campaigns</label>
                          <p>{{client.account.maxCampaigns || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Total Outreach</label>
                          <p>{{client.account.totalOutreach || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Total Engagement</label>
                          <p>{{client.account.totalEngagement || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Min. original content</label>
                          <p>{{client.account.minContent || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Max. original content</label>
                          <p>{{client.account.maxContent || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Estimated Start Date</label>
                          <p>{{client.account.startDate || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Expiry Date</label>
                          <p>{{client.account.expireDate || '-'}}</p>
                        </v-flex>                         -->
                      </v-layout>
                      <div v-if="client.account.deals">
                        <v-divider v-show="client.account.deals.length > 0"></v-divider>
                        <v-row v-show="client.account.deals.length > 0" style="margin-top:20px;margin-bottom:20px;">
                          <v-col cols="12">
                              <v-card text elevation="0">
                              <v-expansion-panels >
                                <v-expansion-panel v-for="(item, index) in client.account.deals" :key="index">
                                  <v-expansion-panel-header style="text-transform: capitalize;" disable-icon-rotate>
                                    <span>
                                      <p class="pr-2 pb-2 mb-0">
                                        {{getProductName(item.name)}}
                                      </p>
                                      <v-chip 
                                      color="green"
                                      outlined
                                      x-small
                                      v-if="getMasterlistCheck(item.IO)">
                                        Masterlist 
                                        <v-icon color="success" small>mdi-check</v-icon>
                                      </v-chip>
                                    </span>
                                    <v-spacer></v-spacer>
                                    <!-- <template v-slot:actions>
                                      {{item.create_at}}
                                    </template> -->
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card-text >
                                      <v-row class="pa-0">
                                        <v-col cols="12" sm="12" md="6" >
                                          <!-- Deals Budget: <strong>{{item.budget}}</strong> -->
                                          <v-flex xs12 md12>
                                            <label>Deals Budget</label>
                                            <p>{{item.budget || '-'}}</p>
                                          </v-flex>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" >
                                          <!-- IO: <strong>{{item.IO}}</strong> -->
                                          <v-flex xs12 md12>
                                            <label>IO</label>
                                            <p>{{item.IO || '-'}}</p>
                                          </v-flex>
                                        </v-col>
                                      </v-row>
                                      <v-row class="pa-0 mt-0">
                                        <v-col cols="12" sm="6" md="6">
                                          <v-flex xs12 md12>
                                            <label>Quote Acceptance Date</label>
                                            <p>{{formattedDate(item.quoteAcceptanceDate) || '-'}}</p>
                                          </v-flex>
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="item.cogsAmount">
                                          <v-flex xs12 md12>
                                            <label>Markup COGS Amount</label>
                                            <p>{{item.cogsAmount || '-'}}</p>
                                          </v-flex>
                                        </v-col>
                                      </v-row>
                                      <v-row class="pa-0 mt-0">
                                        <v-col cols="12" sm="6" v-if="item.vertical">
                                          <v-flex xs12 md12>
                                            <label>Campaign Vertical</label>
                                            <p>{{displayCampaignVerticals(item.vertical)}}</p>
                                          </v-flex>
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="item.country">
                                          <v-flex xs12 md12>
                                            <label>Country</label>
                                            <p>
                                              <v-chip
                                                small
                                                v-for="(item, index) in item.country"
                                                :key="index"
                                                class="ma-1"
                                              >
                                                {{item.name}}
                                              </v-chip>
                                            </p>
                                          </v-flex>
                                        </v-col>
                                      </v-row>
                                      <v-row class="pa-0 mt-0">
                                        <v-col cols="12" sm="6">
                                          <v-flex xs12 md6>
                                            <label>Client Type</label>
                                            <p>{{getClientTypeDisplayValue(item.clientType)}}</p>
                                          </v-flex>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                          <v-flex xs12 md6>
                                            <label>Remarks</label>
                                            <p>{{item.remarks || '-'}}</p>
                                          </v-flex>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12" sm="12" >
                                          <v-expansion-panels>
                                            <v-expansion-panel v-for="(product, pindex) in item.products" :key="pindex">
                                              <v-expansion-panel-header style="text-transform: capitalize;">{{getProductName(product.name)}}</v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                <v-card-text v-show="product.name.toLowerCase() === 'storytell'">
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Account Budget</label>
                                                      <p>{{product.budget || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>No. of Campaigns</label>
                                                      <p>{{product.noOfCampaigns || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Total Outreach</label>
                                                      <p>{{product.totalOutReach || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Total Engagement</label>
                                                      <p>{{product.totalEngagement || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Min. Original Contents</label>
                                                      <p>{{product.minContent || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Max. Original Contents</label>
                                                      <p>{{product.maxContent || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <!-- <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Start Month</label>
                                                      <p>{{formattedMonth(product.startDate) || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>End Month</label>
                                                      <p>{{formattedMonth(product.expireDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout> -->

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Created Date</label>
                                                      <p>{{formattedDate(product.createdDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-card-text>

                                                <v-card-text v-show="product.name.toLowerCase() === 'amplify'">
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Account Budget</label>
                                                      <p>{{product.budget || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Views</label>
                                                      <p>{{product.views || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Min. Original Contents</label>
                                                      <p>{{product.minContent || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Max. Original Contents</label>
                                                      <p>{{product.maxContent || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <!-- <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Start Month</label>
                                                      <p>{{formattedMonth(product.startDate) || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>End Month</label>
                                                      <p>{{formattedMonth(product.expireDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout> -->

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>No. of Contents</label>
                                                      <p>{{product.noOfContents || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Duration</label>
                                                      <p>{{product.duration || '-'}} {{(product.duration > 1 ? 'Months' : 'Month')}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Created Date</label>
                                                      <p>{{formattedDate(product.createdDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-card-text>

                                                <v-card-text v-show="product.name.toLowerCase() === 'uncut'">
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Account Budget</label>
                                                      <p>{{product.budget || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Total Outreach</label>
                                                      <p>{{product.totalOutReach || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Min. Original Contents</label>
                                                      <p>{{product.minContent || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Max. Original Contents</label>
                                                      <p>{{product.maxContent || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md12>
                                                      <label>KPI Onboarded</label>
                                                      <p>{{product.kpiOnboarded || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <!-- <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Start Month</label>
                                                      <p>{{formattedMonth(product.startDate) || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>End Month</label>
                                                      <p>{{formattedMonth(product.endDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout> -->

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Created Date</label>
                                                      <p>{{formattedDate(product.createdDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-card-text>

                                                <v-card-text v-show="product.name.toLowerCase() === 'aok'">
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Account Budget</label>
                                                      <p>{{product.budget || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Total Outreach</label>
                                                      <p>{{product.totalOutReach || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Min. Original Contents</label>
                                                      <p>{{product.minContent || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>Max. Original Contents</label>
                                                      <p>{{product.maxContent || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <v-layout wrap>
                                                    <v-flex xs12 md12>
                                                      <label>KPI Onboarded</label>
                                                      <p>{{product.kpiOnboarded || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>

                                                  <!-- <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Start Month</label>
                                                      <p>{{formattedMonth(product.startDate) || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>End Month</label>
                                                      <p>{{formattedMonth(product.endDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout> -->

                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Created Date</label>
                                                      <p>{{formattedDate(product.createdDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-card-text>

                                                <v-card-text v-show="product.name.toLowerCase() === 'others'">
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Account Budget</label>
                                                      <p>{{product.budget || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                  <!-- <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Start Month</label>
                                                      <p>{{formattedMonth(product.startDate) || '-'}}</p>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                      <label>End Month</label>
                                                      <p>{{formattedMonth(product.expireDate) || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout> -->
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Remark</label>
                                                      <p>{{product.remark || '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                  <v-layout wrap>
                                                    <v-flex xs12 md6>
                                                      <label>Nature of deal</label>
                                                      <p>{{product.natureOfDeal ? displayNatureOfDeals(product.natureOfDeal) : '-'}}</p>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-card-text>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                        </v-col>
                                      </v-row>
                                    </v-card-text>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-if="client.account.products">
                        <v-divider v-show="client.account.products.length > 0"></v-divider>
                        <v-row v-show="client.account.products.length > 0" style="margin-top:20px;margin-bottom:20px;">
                          <v-col cols="12">
                              <v-card text elevation="0">
                              <v-expansion-panels multiple>
                                <v-expansion-panel v-for="(item, index) in client.account.products" :key="index">
                                  <v-expansion-panel-header style="text-transform: capitalize;">{{getProductName(item.name)}}</v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card-text v-show="item.name.toLowerCase() === 'storytell'">
                                      <v-layout wrap>
                                        <v-flex xs12 md6>
                                          <label>Account Budget</label>
                                          <p>{{item.budget}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>No. of Campaigns</label>
                                          <p>{{item.noOfCampaigns}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Total Outreach</label>
                                          <p>{{item.totalOutReach}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Total Engagement</label>
                                          <p>{{item.totalEngagement}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Min. Original Contents</label>
                                          <p>{{item.minContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Max. Original Contents</label>
                                          <p>{{item.maxContent}}</p>
                                        </v-flex>
                                        <!-- <v-flex xs12 md6>
                                          <label>Start Month</label>
                                          <p>{{formattedMonth(item.startDate)}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>End Month</label>
                                          <p>{{formattedMonth(item.expireDate)}}</p>
                                        </v-flex> -->
                                        <v-flex xs12 md6>
                                          <label>Created Date</label>
                                          <p>{{formattedDate(item.createdDate)}}</p>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-text v-show="item.name.toLowerCase() === 'amplify'">
                                      <v-layout wrap>
                                        <v-flex xs12 md6>
                                          <label>Account Budget</label>
                                          <p>{{item.budget}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Views</label>
                                          <p>{{item.views}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Min. Original Contents</label>
                                          <p>{{item.minContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Max. Original Contents</label>
                                          <p>{{item.maxContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>No. of Contents</label>
                                          <p>{{item.noOfContents}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Duration</label>
                                          <p>{{item.duration}} {{(item.duration > 1 ? 'Months' : 'Month')}}</p>
                                        </v-flex>
                                        <!-- <v-flex xs12 md6>
                                          <label>Start Month</label>
                                          <p>{{formattedMonth(item.startDate)}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>End Month</label>
                                          <p>{{formattedMonth(item.endDate)}}</p>
                                        </v-flex> -->
                                        <v-flex xs12 md6>
                                          <label>Created Date</label>
                                          <p>{{formattedDate(item.createdDate)}}</p>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-text v-show="item.name.toLowerCase() === 'uncut'">
                                      <v-layout wrap>
                                        <v-flex xs12 md6>
                                          <label>Account Budget</label>
                                          <p>{{item.budget}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Min. Original Contents</label>
                                          <p>{{item.minContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Max. Original Contents</label>
                                          <p>{{item.maxContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md12>
                                          <label>KPI Onboarded</label>
                                          <p>{{item.kpiOnboarded || '-'}}</p>
                                        </v-flex>
                                        <!-- <v-flex xs12 md6>
                                          <label>Start Month</label>
                                          <p>{{formattedDuration(item.startDate)}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>End Month</label>
                                          <p>{{formattedDate(item.endDate)}}</p>
                                        </v-flex> -->
                                        <v-flex xs12 md6>
                                          <label>Created Date</label>
                                          <p>{{formattedDate(item.createdDate)}}</p>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-text v-show="item.name.toLowerCase() === 'aok'">
                                      <v-layout wrap>
                                        <v-flex xs12 md6>
                                          <label>Account Budget</label>
                                          <p>{{item.budget}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Total Outreach</label>
                                          <p>{{item.totalOutReach}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Min. Original Contents</label>
                                          <p>{{item.minContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Max. Original Contents</label>
                                          <p>{{item.maxContent}}</p>
                                        </v-flex>
                                        <v-flex xs12 md12>
                                          <label>KPI Onboarded</label>
                                          <p>{{item.kpiOnboarded || '-'}}</p>
                                        </v-flex>
                                        <!-- <v-flex xs12 md6>
                                          <label>Start Month</label>
                                          <p>{{formattedDuration(item.startDate)}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>End Month</label>
                                          <p>{{formattedDate(item.endDate)}}</p>
                                        </v-flex> -->
                                        <v-flex xs12 md6>
                                          <label>Created Date</label>
                                          <p>{{formattedDate(item.createdDate)}}</p>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-text v-show="product.name.toLowerCase() === 'others'">
                                      <v-layout wrap>
                                        <v-flex xs12 md6>
                                          <label>Account Budget</label>
                                          <p>{{product.budget || '-'}}</p>
                                        </v-flex>
                                        <!-- <v-flex xs12 md6>
                                          <label>Start Month</label>
                                          <p>{{formattedMonth(product.startDate) || '-'}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>End Month</label>
                                          <p>{{formattedMonth(product.expireDate) || '-'}}</p>
                                        </v-flex> -->
                                        <v-flex xs12 md6>
                                          <label>Remark</label>
                                          <p>{{product.remark || '-'}}</p>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <label>Nature of deal</label>
                                          <p>{{product.natureOfDeal || '-'}}</p>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Billing Details</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container>
                      <v-layout wrap>
                        <v-flex xs12 md6>
                          <label>Payment Mode</label>
                          <p>{{clientPaymentModesDisplay(client.paymentMode) || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Billing Address</label>
                          <p>{{client.billingAddress || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Billing Contact</label>
                          <p>{{client.billingPhoneNumber || '-'}}</p>
                        </v-flex>
                        <v-flex xs12 md6>
                          <label>Billing Email</label>
                          <p>{{client.billingEmail || '-'}}</p>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  Xero Integration
                  <template v-slot:actions>
                    <v-icon color="error" v-if="!client.xeroContact">mdi-alert-circle</v-icon>
                    <v-icon color="success" v-if="client.xeroContact">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-banner single-line rounded v-if="!client.xeroContact">
                    <v-icon slot="icon" color="warning" size="36">mdi-lan-disconnect</v-icon>This client is not connected with Xero
                  </v-banner>
                  <v-card outlined v-if="client.xeroContact">
                    <v-card-title>{{client.xeroContact.Name}}</v-card-title>
                    <v-card-subtitle>{{client.xeroContact.EmailAddress}}</v-card-subtitle>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel> -->
            </v-expansion-panels>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-toolbar dense class="elevation-2">
      <v-toolbar-title>View Client Data</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('input')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>-->
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
import clientConfig from './clientConfig.js';
// import campaignConfig from '../Campaign/config';
import UserAPIs from '../User/userAPIs.js';
import campaignAPIs from '../Campaign/campaignAPIs';
import moment from 'moment'
import campaignHelper from '../Campaign/campaignHelper';

export default {
  name: 'ViewClientModal',
  props: {
    clientData: Object,
    value: Boolean
  },
  data() {
    return {
      panels: [0, 2],
      salePersonUser: {},
      userList: [],
      assignUsers: [],
      dedicatedUserList: [],
      supportingUserList: [],
      client: {
        name: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: '',
          totalOutreach: '',
          totalEngagement: '',
          minContent: '',
          maxContent: '',
          maxCampaigns: '',
          startDate: '',
          expireDate: ''
        },
        contacts: []
      },
      // countries: campaignConfig.targetAudienceDisplay.LOCATION,
      clientTypes: [
        {
          title: 'Direct',
          value: 'direct'
        },
        {
          title: 'Agency',
          value: 'agency'
        }
      ],
      natureOfDealOptions: [
        'Loading Fees/whitelisting',
        'Physical Attendance/Event'
      ],
      campaigns: []
    };
  },
  methods: {
    clientPaymentModesDisplay: function(mode) {
      let display = this.clientPaymentModes.filter(item => item.value === mode);
      return display.length > 0 ? display[0].name : '';
    },
    fetchUserList: async function(clientId) {
      // fetch User who is assigned to that client
      UserAPIs.findByRole(clientId)
        .then(resp => {
          this.userList = resp.users;
        })
        .catch(err => console.error(err));
    },
    fetchUserSalePerson: function(userID) {
      if (!userID) return;
      UserAPIs.getUser(userID)
        .then(response => {
          this.salePersonUser = response;
        })
        .catch(err => console.error(err));
    },
    getHandleUsers: async function(client) {
      // Get all CO user by role
      let resp = await UserAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (resp) this.CO = resp.users
      // Get all AM user by role
      resp = await UserAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      if (resp) this.AM = resp.users
      this.assignUsers = Object.assign([], [...this.CO, ...this.AM])
      if (client.handledBy) {
        this.dedicatedUserList = this.assignUsers.filter(a => client.handledBy.includes(a.id))
      }
      if (client.supportedBy) {
        this.supportingUserList = this.assignUsers.filter(a => client.supportedBy.includes(a.id))
      }
    },
    addDefaultContact(name = '', email = '') {
      this.client.contacts.push({
        contactName: name,
        email: email,
        includeEmail: false
      })
    },
    formattedDate(date) {
      return moment(date).format('DD MMM, YYYY')
    },
    formattedMonth(date) {
      return moment(date).format('MMM, YYYY')
    },
    formattedDuration(date) {
      return moment(date).format('MMM, YYYY')
    },
    getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut'
      }
      return itemName
    },
    displayCampaignVerticals(vertical) {
      let selectedCampaignVertical = []
      if (vertical) {
        this.campaignVerticals.map(item => {
          vertical.map(v => {
            if (item.id === v.id) {
              selectedCampaignVertical.push(item)
            }
          })
        })
      }
      return selectedCampaignVertical.map(s => s.name).join(', ')
    },
    getCountryDisplayValueFromSelect: function(value) {
      if (typeof value === 'string') return value
      var selectedOption = this.countries.filter(option => {
        return value.includes(option.value)
      });
      return selectedOption ? selectedOption.map(o => o.text).join(', ') : '-';
    },
    getClientTypeDisplayValue(value) {
      if (value) {
        let matchClient = this.clientTypes.find(c => c.value === value)
        if (matchClient) return matchClient.title
      }
      return '-'
    },
    displayNatureOfDeals(deals) {
      return Array.isArray(deals) ? deals.map(d => d.name || '').join(', ') : ''
    },
    async getCampaignsByClientID() {
      // get all campaigns
      let response = await campaignAPIs.getCampaignsByClientID(this.client.id)
      if (response) {
        this.campaigns = response.campaigns.map(r => Object.assign({}, {id: r.id, name: r.name}))
      }
    },
    getMasterlistCheck(IONumber) {
      let masterListExist = this.masterLists.find(m => m.quoteNo === this.cutIO(IONumber))
      if (masterListExist) return true
      return false
    },
    cutIO(IO) {
      var re = new RegExp('IO-', 'g')
      return IO.replace(re, '')
    }
  },
  watch: {
    clientData: async function(newClientData) {
      await this.$store.dispatch('campaign/getCountries')
      if (newClientData.account && newClientData.account.deals) {
        newClientData.account.deals = newClientData.account.deals.map(deal => {
          if (deal.country) {
            if (this.countries.length) {
              deal.country = campaignHelper.formatCountry(this.countries, deal.country || [])
            }
          }
          return deal
        })
        this.accountDeals = newClientData.account.deals
        this.dealCounter = newClientData.account.deals.length
      }
      this.client = Object.assign({}, newClientData);
      if (!newClientData.account) {
        this.client.account = {};
      }

      this.fetchUserList(this.client.id);
      this.fetchUserSalePerson(this.client.salePerson);
      this.getHandleUsers(this.client)
      // check for multiple contacts, campaigns
      await this.getCampaignsByClientID()
      if (this.client.contacts === undefined) {
        this.client.contacts = []
        this.addDefaultContact(this.client.contactName, this.client.email)
      } else {
        this.client.contacts = this.client.contacts.map(c => {
          if (c.campaigns !== undefined) {
            c.campaigns = this.campaigns.filter(campaign => c.campaigns.includes(campaign.id))
          }
          return c
        })
      }
    }
  },
  computed: {
    ...mapState({
      countries: state => state.campaign.countries,
      campaignVerticals: state => state.campaign.campaignVerticals,
      masterLists: state => state.campaign.masterLists
    }),
    clientPaymentModes: function() {
      return clientConfig.clientPaymentModes;
    }
  },
  async mounted() {
    UserAPIs
      .getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      .then(response => {
        this.CO = response.users;
      })
      .catch(error => {
        console.log('error', error);
      });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// ViewClientModal.vue?10cb1e47